import React, { useEffect, useRef, useState } from 'react';
import '../campaign/CreateCampaign.scss';
import { useDispatch, connect } from 'react-redux';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import {
  createStampCampaignBreads,
} from '../../../config/CustomBreadConfig';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { createAction } from '../../../utils';
import {
  saveDataToSessionStorage,
  removeDataFromSessionStorage,
  stampSessionDataKey,
} from '../../../models/CreateCampaignModel';
import {
  getCampaignCreateSuccessStepBar,
  getCampaignStepBarNameWithType,
} from '../../../components/base/prompt/NextStepConfig';
import { URLFilterKeys, URLFragments } from '../../../components/campaign/CampaignUrlConfig';
import queryString from 'query-string';
import { CampaignType, APIStatus, ActionType } from '../../../config/CustomEnums';
import BaseForm from '../../../components/base/v2/BaseForm';
import CreateStampCampaignStepOneV2 from 'components/stampCampaign/stampCampaignCreation/CreateStampCampaignStepOneV2';
import CreateStampCampaignStepTwoV2 from 'components/stampCampaign/stampCampaignCreation/CreateStampCampaignStepTwoV2';
import CreateStampCampaignStepThreeV2 from 'components/stampCampaign/stampCampaignCreation/CreateStampCampaignStepThreeV2';
import { stepNamesConfig } from 'models/CampaignStreamlineModel';
import RequireCampaignNamePrompt from 'components/campaignStreamline/RequireCampaignNamePrompt';
import CreateStampCampaignStepFourV2 from 'components/stampCampaign/stampCampaignCreation/CreateStampCampaignStepFourV2';
import Loading from 'components/base/Loading';

function CreateStampCampaign({
  stepConfig,
  currentStep,
  campaignPublish,
  linkedEarningRules,
  linkedCoupon,
  campaign = {},
  formHasSubmitted,
  hasUpdatedDefaultValues,
  detailLoading,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const getFormValueRef = useRef();
  const [showRequireNamePrompt, setShowRequireNamePrompt] = useState({
    show:false,
    actionType: null,
  });
  const closeRequireNamePrompt = () => {
    setShowRequireNamePrompt({
      show: false,
      actionType: null,
    })
  }
  
  const search = queryString.parse(history.location.search);

  const campaignType = CampaignType.stampCampaign;
  const campaignId = campaign.pk;
  const campaignGeneralName = campaign.translations?.en?.generalName;

  const onStepChange = (step) => {
    dispatch(createAction("campaignStreamline/stepChange")({
      step
    }))
  }

  const saveDraftAction = (buttonAction) => {
    if (!getFormValueRef.current) {
      return
    }
    dispatch(createAction("createCampaign/createOrUpdateCampaignV2")({
      data: getFormValueRef.current(),
      actionType: buttonAction || ActionType.save,
      isStamp: true,
    }))
  }


  const onClickSaveTemp = ({
    buttonAction,
    getValues,
    replaceDefaultAction,
  }) => {
    getFormValueRef.current = getValues;
    const campaignName = getValues('translations.en.generalName');
    if (!campaignName) {
      setShowRequireNamePrompt({
        show: true,
        actionType: buttonAction,
      })
      return;
    };
    if (replaceDefaultAction) {
      replaceDefaultAction()
    }
    saveDraftAction(buttonAction);
  }


  useEffect(() => {
    dispatch({ type: 'createCampaign/clearData' });
    dispatch(createAction("campaignStreamline/updateSteps")({
      currentStep: 0,
      customNameList: stepNamesConfig.stampCampaign,
      hideFirstStep: false,
    }))
    if (!history.location.search) {
      const campaignId = params.id;
      if (campaignId) {
        dispatch(
          createAction('createCampaign/getOneCampaign')({ id: campaignId }),
        );
      } else {
        dispatch(
          createAction('createCampaign/loadCampaignFromCookie')({
            resume: location.state?.resume,
            isStamp: true,
          }),
        );
      }
      dispatch(createAction('brand/getCurrentPageBrands')());
    }
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));
    return () => {
      dispatch({ type: 'createCampaign/clearData' });
      dispatch({ type: 'campaignStreamline/clearData' })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const requiredCampaignNamePopup = (
    <RequireCampaignNamePrompt
      show={showRequireNamePrompt?.show}
      onHide={() => {
        closeRequireNamePrompt()
      }}
      onConfirm={() => {
        saveDraftAction(showRequireNamePrompt?.actionType);
        closeRequireNamePrompt()
      }}
    />
  )
  const stepSet = [
    <CreateStampCampaignStepOneV2 onStepChange={onStepChange} onSaveTemp={onClickSaveTemp} />,
    <CreateStampCampaignStepTwoV2 onStepChange={onStepChange} onSaveTemp={onClickSaveTemp} />,
    <CreateStampCampaignStepThreeV2 onStepChange={onStepChange} onSaveTemp={onClickSaveTemp} />,
    <CreateStampCampaignStepFourV2 onStepChange={onStepChange} onSaveTemp={onClickSaveTemp} />,
  ].map(item => (
    <>
      {item}
      {requiredCampaignNamePopup}
    </>
  ))

  const toCampaignList = () => {
    const search = queryString.stringify({
      [URLFilterKeys.page]: 1,
      [URLFilterKeys.searchKey]: '',
      [URLFilterKeys.rank]: true,
    });
    history.push({
      pathname: '/stamp_campaigns',
      hash: URLFragments.list,
      search: search,
    });
  };

  const getCompleteSteps = () => {
    const urlId = search.id;
    const linkedId =
      CampaignType.couponsCampaign === campaignType
        ? linkedCoupon?.pk
        : linkedEarningRules?.pk;
    let showMoreSteps = location.search;
    if (urlId + '' !== linkedId + '') {
      showMoreSteps = false;
    }
    return getCampaignCreateSuccessStepBar(campaignType, showMoreSteps);
  };

  if (detailLoading === APIStatus.calling) {
    return <Loading />
  }
  return (
    <>
      <BaseForm
        useStepsV2
        defaultValues={campaign}
        formHasSubmitted={formHasSubmitted}
        hasUpdatedDefaultValues={hasUpdatedDefaultValues}
        tempSave={(save, getValues) => {
          if (save) {
            saveDataToSessionStorage(getValues(), true);
          } else {
            removeDataFromSessionStorage(true);
          }
        }}
        showFinishPop={campaignPublish === APIStatus.success}
        nextStepConfig={{
          title: 'Successfully Published!',
          description:
            'The campaign is successfully published.\n Let your customers know about the campaign.',
          steps: {
            stepNames: getCompleteSteps(),
            current: getCampaignStepBarNameWithType(campaignType),
          },
          onHide: () => { },
          buttons: [
            {
              text: 'Create message',
              action: () => {
                history.push({
                  pathname: '/messages/create',
                  search: `${location.search}&campaign=${campaignId}${location.search ? '' : '&type=' + campaignType
                    }`,
                });
              },
              requires: PermissionCodes.addMessage,
            },
            {
              text: 'Maybe Later',
              action: toCampaignList,
              requires: PermissionCodes.changeEarningRule,
            },
          ],
        }}
        continueCreateConfig={{
          onConfirm: () => {
            history.push(history.location.state?.from);
          },
          onCancel: toCampaignList,
          onClose: toCampaignList,
        }}
        sessionDataKey={stampSessionDataKey}
        content={stepSet}
        currentStep={currentStep}
        stepOnClick={(step) => {
          dispatch({ type: 'campaignStreamline/stepChange', payload: { step: step } })
        }}
        breadcrumb={<CustomBreadcrumb breadcrumbs={createStampCampaignBreads(campaignId ? campaignGeneralName : 'Create Stamp campaign')} />}
        stepsConfig={stepConfig}
        caution={{
          detail: '',
          title: campaignId ? campaignGeneralName : 'Create Stamp campaign',
        }}
        hasleavePagePrompt={params.id}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  stepConfig: state.campaignStreamline.stepConfig,
  currentStep: state.campaignStreamline.currentStep,
  linkedEarningRules: state.createCampaign.campaign?.linkedEarningRules,
  linkedCoupon: state.createCampaign.campaign?.linkedCoupon,
  campaignPublish: state.createCampaign.campaignPublish,

  campaign: state.createCampaign.campaign,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
  hasUpdatedDefaultValues: state.createCampaign.hasUpdatedDefaultValues,
  detailLoading: state.createCampaign.detailLoading,
})

export default connect(mapPropsToState)(CreateStampCampaign);
